import { isAddressEqual } from 'viem';
export const nativeTokenAddress = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';
export function isNativeToken(address) {
    return isAddressEqual(nativeTokenAddress, address);
}
//# sourceMappingURL=is-native-token.js.map